import React from 'react';
import {
    Table,
    Statistic
} from 'antd';

const columns = [
    {
      title: 'สินค้า',
      dataIndex: 'product',
      key: 'product',
      render: (_, columns) => `${columns.product?.name}:${columns.product?.brand?.name} ${columns.product?.description}`
    },
    {
      title: 'ราคา',
      dataIndex: 'price',
      key: 'price',
      render: (text, _) => <Statistic value={ text} precision={2} valueStyle={{fontSize:14}}/>
    },
    {
      title: 'จำนวน',
      dataIndex: 'quantity',
      key: 'quantity',
    },
];

function TransactionItems({ items }) {
    // console.log(items);
    return (
        <div>
            <Table
                rowKey={(record) => record.id}
                columns={columns}
                dataSource={items}
                pagination={false}
                scroll={{
                    x: 1200,
                }}
            />
        </div>
    )
}

export default TransactionItems